module.exports = __webpack_public_path__ + "img/04.26cfce72.png";